// How long the record is, in words — and never as a date range.
//
// Three surfaces say this: the landing note, the briefing's written summary and
// the caveat under the readings. They used to each build "11 years — 2015–2025 —"
// from manifest.years, which meant the atlas advertised its own edges: a reader
// saw a start year and asked what happened before it, and every merge quietly
// rewrote the sentence. The blend keeps a rolling decade (MERGE_WINDOW), so the
// honest and stable phrasing is the LENGTH of the record, not its endpoints.
//
// Still derived from manifest.years rather than written into the markup: if the
// window is ever changed, or a year is missing, the prose follows rather than
// lying.

/** "a decade", "9 years", "one year", or "" when the manifest carries none. */
export function yearsPhrase(years: string[]): string {
  const n = years.length;
  if (!n) return '';
  if (n === 1) return 'one year';
  if (n === 10) return 'a decade';
  return `${n} years`;
}

/** The same phrase at the head of a sentence. */
export function yearsPhraseCap(years: string[]): string {
  const p = yearsPhrase(years);
  return p ? p.charAt(0).toUpperCase() + p.slice(1) : '';
}
